import { render, staticRenderFns } from "./CreatePortfolio.vue?vue&type=template&id=5f1c04d7&"
import script from "./CreatePortfolio.vue?vue&type=script&lang=js&"
export * from "./CreatePortfolio.vue?vue&type=script&lang=js&"
import style0 from "./CreatePortfolio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports